import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import FullSizeHeroBannerComponent from './js/full-size-hero-banner.component';

ComponentsFactory.getInstance().define('full-size-hero-banner-component', FullSizeHeroBannerComponent);
